// src/hooks/useFeatures.js
import { useEffect, useState } from "react";
import { getFeatures } from "@/services/features.service";
import { localizeField } from "@/utils/i18nBackend";

export function useFeatures(isAR = false) {
  const [features, setFeatures] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;

    async function fetchFeatures() {
      try {
        setLoading(true);
        setError(null);

        const result = await getFeatures();

        const formattedFeatures = Array.isArray(result?.data)
          ? result.data
              .filter((item) => localizeField(item, "title") || localizeField(item, "desc"))
              .map((item) => ({
                id: item.id,
                title: localizeField(item, "title"),
                desc: localizeField(item, "desc"),
                icon: item.icon,
              }))
          : [];

        if (active) {
          setFeatures(formattedFeatures);
        }
      } catch (err) {
        if (active) {
          setError(
            err?.response?.data?.message ||
              err?.message ||
              "Failed to load features"
          );
        }
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    }

    fetchFeatures();

    return () => {
      active = false;
    };
  }, [isAR]);

  return {
    features,
    loading,
    error,
  };
}